import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";

import { OTHER_MATTERS } from "../MeetingMinutesForm.options";
import { restoreMeetingMinutes } from "../MeetingMinutesForm.rules";
import {
  MeetingMinutesData,
  meetingMinutesSchema,
} from "../MeetingMinutesForm.schema";

const emptyTaskRow = () => ({ task: "", owner: "", deadline: "", status: "" });

export function useMeetingMinutesForm(initialData?: Record<string, unknown>) {
  return useForm<MeetingMinutesData>({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: zodResolver(meetingMinutesSchema) as any,
    defaultValues: initialData
      ? restoreMeetingMinutes(initialData)
      : {
          docRefMeetPlace: "",
          docRefMeetDate: "",
          docRefMeetPart: "",
          docRefDet: "",
          otherCases: Object.fromEntries(
            OTHER_MATTERS.map((m) => [m.key, false])
          ) as Record<(typeof OTHER_MATTERS)[number]["key"], boolean>,
          tasks: [emptyTaskRow()],
        },
  });
}

export { emptyTaskRow };
